import { createContext } from 'react'
import socket, { fetch, authenticate, clearAuthentication } from 'src/api/socket'
import { get, post } from 'src/api/fetch'

export const defaultContext = {
  socket, fetch, authenticate, clearAuthentication, // socket.io
  get, post,     // REST-API
}

const ApiContext = createContext(defaultContext)

export default ApiContext
